class RCIGameLayer {

  /* ========================================================================
   * Puzzle.js
   * ======================================================================== */
  constructor( el ) {
    this.inited = false;
    this.el = el;
    this.opened = false;
    this.timeoutcheck = null;
    this.options = Object.assign({
      id:null,
      gameid: null,
      gridid: null,
      levelid: null,
      urlcategory: null,
      adheaderbidding: false,
    }, el.dataset );
  }

  async openRCIGameLayer() {
    let rciGame = this;
    if (rciGame.opened) return;
    let overlay = document.createElement('div');
    overlay.classList.add( 'rcigame-overlay' );
    if(rciGame.options.gameid == 'wordle')
    {
      let divPuzzle = '<div id="puzzle-portal" data-gametype="Wordguess" data-puzzleid="'+rciGame.options.gridid+'" data-customerid="wlpp_notretemps" data-publicpath="https://web.keesing.com/pub/player/v2.23.13/dist/"></div>';

      if(rciGame.options.gridid.includes('wordguess'))
      {
        divPuzzle = '<div id="puzzle-portal" data-gametype="Wordguess" data-puzzleid="'+rciGame.options.gridid+'" data-customerid="notretemps"></div>';
      }

      overlay.innerHTML =
        '<span class="rcigame-close">FERMER&nbsp;<i class="im im-cancel"></i></span>' +
        '<a href="' +rciGame.options.urlcategory + '"><span class="rcigame-list">RETROUVEZ NOS AUTRES WORDLE</span></a>' +
        '<div class="rcigame-wordle-container">' + divPuzzle +
        '</div>' +
        '<div class="rcigame-ad-container wordle-ad-container"><div id="div-gpt-ad-ingame"></div><div id="div-gpt-ad-ingamemiddle" class="mt-2"></div><div id="div-gpt-ad-ingamebas" class="mt-2"></div></div>';
    }
    else{
      overlay.innerHTML =
        '<span class="rcigame-close">FERMER&nbsp;<i class="im im-cancel"></i></span>' +
        '<a id="othergame" data-id="'+rciGame.options.id+'" data-gameid="' +rciGame.options.gameid + '" data-levelid="'+rciGame.options.levelid+'"><span class="rcigame-list">Jouer à une autre grille</span></a>' +
        '<div class="rcigame-video-container disabled">'+
        '<div id="rcigame-content"></div>'+
        '</div>'+
        '<div class="rcigame-iframe-container">' +
        '<iframe class="rcigame-iframe" src="' + rciGame.options.src + '" width="100%" height="100%" border="0" scrolling="no" seamless></iframe>' +
        '</div>' +
        '<div class="rcigame-ad-container"><div id="div-gpt-ad-ingame"></div><div id="div-gpt-ad-ingamemiddle" class="mt-2"></div><div id="div-gpt-ad-ingamebas" class="mt-2"></div></div>';
    }
    document.body.appendChild( overlay );


    if(rciGame.options.gameid == 'wordle')
    {
      let script = document.createElement('script');
      script.type = 'text/javascript';
      let bundleWordle = 'https://web.keesing.com/pub/player/v2.23.13/dist/main-bundle.js';

      if(rciGame.options.gridid.includes('wordguess'))
      {
        bundleWordle =  'https://web.keesing.com/pub/bundle-loader/bundle-loader.js';
        script.dataset.wlppBundle="player";
      }

      script.src =  bundleWordle;

      document.body.appendChild(script);
    }

    document.documentElement.classList.add('noscroll');
    overlay.querySelector( '.rcigame-close' ).addEventListener( 'click', (e) => {
      e.preventDefault();
      rciGame.closeRCIGameLayer();
    });

    let othergame =  overlay.querySelector('#othergame');


    if(othergame){
      othergame.addEventListener('click' , (e) => {
        e.preventDefault();
        rciGame.loadOtherGame(overlay,othergame);
      });
    }

    rciGame.opened = true;
    rciGame.loadVideo();
    rciGame.createAds();


    return;
  }

  async closeRCIGameLayer() {
    let rciGame = this;
    rciGame.removeAds();
    document.querySelector( '.rcigame-overlay' ).remove();
    document.documentElement.classList.remove('noscroll');
    rciGame.opened = false;
  }

  async loadOtherGame(overlay,othergame){

    
    let id = othergame.dataset.id;
    let gameid = othergame.dataset.gameid;
    let levelid = othergame.dataset.levelid;

    // send ga event
    if( typeof dataLayer !== 'undefined' ) {
      dataLayer.push({event:"pageview-dynamic"})
    }
    if( typeof _wsq !== undefined ) {
      _wsq.push(['_wysistat']);
    }

    let rciGame = this;
    fetch( '/load-other-game', {
      cache: "no-store",
      method: "POST",
      credentials:"omit",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: id,
        gameid: gameid,
        levelid:levelid
      }),
    } ).then( (response) => {
    return response.json();
   }).then( (gameresponse) => {
      if( gameresponse.success ){
       document.querySelector('.rcigame-iframe-container iframe.rcigame-iframe').setAttribute('src',gameresponse.iframeurl);
       overlay.querySelector('#othergame').dataset.id = gameresponse.newid;
    //   rciGame.loadVideo();
      } else {
        console.error( gameresponse.message );
      }
    });
  }

  async loadVideo(){
    let rciGame = this;

    if( window['adblocked'] === false &&  typeof googletag !== 'undefined' && googletag && typeof googletag.slots != 'undefined' ) {
      let rciVideoContainer = document.querySelector('.rcigame-video-container');


      googletag.cmd.push(function( ) {
        if(rciGame.options.gameid == 'mcroises' && window.location.origin != 'https://www.notretemps.com'){
          console.log('---- show-game-video ---');
          Hubvisor('bayard:show-game-video', {
                divId: 'rcigame-content',
                onVideoEnd: () => {
                  document.querySelector('#rcigame-content').innerHTML = '';
                  rciVideoContainer.classList.add('disabled');
                }
            },
          () => {
            rciVideoContainer.classList.remove('disabled');
          }
          )
        }
      });
    }
  }

  async createAds() {
    let rciGame = this;
    if( typeof googletag !== 'undefined' && googletag && typeof googletag.slots != 'undefined'  ) {
      googletag.cmd.push(function( ) {
        if( typeof googletag.slots.ingame !== 'undefined' ){
          googletag.destroySlots([googletag.slots.ingame]);
        }
        if( typeof googletag.slots.ingamemiddle !== 'undefined' ){
          googletag.destroySlots([googletag.slots.ingamemiddle]);
        }
        if( typeof googletag.slots.ingamebas !== 'undefined' ){
          googletag.destroySlots([googletag.slots.ingamebas]);
        }
        googletag.slots.ingame = googletag.defineSlot("/99360173/notretempsv3/jeux/ingame",[[300, 250],[320, 50],[728, 90],[970, 90],[234, 60],[120, 60],[88, 31],[120, 90],[468, 60]],"div-gpt-ad-ingame").setTargeting("pos",["ingame"]).addService(googletag.pubads());
        googletag.slots.ingamemiddle = googletag.defineSlot("/99360173/notretempsv3/jeux/ingamemiddle",[[300, 250],[320, 50]],"div-gpt-ad-ingamemiddle").setTargeting("pos",["ingamemiddle"]).addService(googletag.pubads());
        googletag.slots.ingamebas = googletag.defineSlot("/99360173/notretempsv3/jeux/ingamebas",[[300, 250],[320, 50]],"div-gpt-ad-ingamebas").setTargeting("pos",["ingamebas"]).addService(googletag.pubads());


        let mapping = googletag.sizeMapping()
                                .addSize( [992, 730], [[300, 250],[320, 50]] )
                                .addSize( [992, 0], [[300, 250],[320, 50]] )
                                .addSize( [990, 0], [[970,90],[728,90],[468, 60],[120,90],[234, 60],[320,50],[88, 31]] )
                                .addSize( [748, 0], [[728,90],[468, 60],[234, 60],[120, 60],[320,50],[88, 31]] )
                                .addSize( [488, 0], [[468, 60],[234, 60],[120, 60],[320,50],[88, 31]] )
                                .addSize( [340, 0], [[234, 60],[120, 60],[320,50],[88, 31]] )
                                .addSize( [0, 0], [[234, 60],[120, 60],[88, 31]] )
                                .build();

        let mappingbas = googletag.sizeMapping()
                              .addSize( [992, 0], [[300,250],[320, 50]] )
                              .addSize( [990, 0], [[970,90],[728,90],[468, 60],[120,90],[234, 60],[320,50],[88, 31]] )
                              .addSize([748, 0], [])
                              .build();

      let mappingmiddle = googletag.sizeMapping()
                              .addSize( [992, 0], [[300, 250],[320, 50]] )
                              .addSize( [990, 0], [[300, 250],[320, 50]] )
                              .addSize([748, 0], [])
                              .build();

        googletag.slots.ingame.defineSizeMapping(mapping);
        googletag.display("div-gpt-ad-ingame");

        googletag.slots.ingamemiddle.defineSizeMapping(mappingmiddle);
        googletag.display("div-gpt-ad-ingamemiddle");

        googletag.slots.ingamebas.defineSizeMapping(mappingbas);
        googletag.display("div-gpt-ad-ingamebas");

        Hubvisor('refresh', [googletag.slots.ingame.getSlotElementId(),googletag.slots.ingamebas.getSlotElementId()], function() {
          googletag.pubads().refresh(googletag.slots.ingame);
          googletag.pubads().refresh(googletag.slots.ingamemiddle);
          googletag.pubads().refresh(googletag.slots.ingamebas);
        });
      });
    }
  }

  async removeAds() {
    let rciGame = this;
    if( typeof googletag !== 'undefined' && googletag && typeof googletag.slots != 'undefined' ) {
      googletag.cmd.push( function() {
        if( typeof googletag.slots.ingame !== 'undefined' ){
          googletag.destroySlots([googletag.slots.ingame]);
        }
        if( typeof googletag.slots.ingamemiddle !== 'undefined' ){
          googletag.destroySlots([googletag.slots.ingamemiddle]);
        }
        if( typeof googletag.slots.ingamebas !== 'undefined' ){
          googletag.destroySlots([googletag.slots.ingamebas]);
        }
      } );
    }

    if( typeof googletag.slots != 'undefined' && typeof googletag.slots.ingame !== 'undefined' ){
      googletag.slots.ingame = null;
    }

    if( typeof googletag.slots != 'undefined' && typeof googletag.slots.ingamebas !== 'undefined' ){
      googletag.slots.ingamebas = null;
    }
  }

  async init(){
    let rciGame = this;
    rciGame.el.addEventListener( 'click', (e) => {
      e.preventDefault();
      rciGame.openRCIGameLayer();
    });

    // remove loading
    if( rciGame.el.querySelector('.playbtn') ){
      rciGame.el.querySelector('.playbtn').innerHTML = 'Jouer';
    }
  }
}


let gptadslots = gptadslots || [];
DOMReady( function(){
  [... document.querySelectorAll('.rcigame')].map( l => {
    let rcigame = new RCIGameLayer(l);
    rcigame.init();
  });
});
